/* import WORK_CALENDAR_TYPE_COLORS from "@/components/global_components/calendar/data/WORK_CALENDAR_TYPE_COLORS"; */
import dateService from "@/services/date-service";
import {parseFilters} from '@/services/parsing_services/filter-service'

/* const FALLBACK_COLOR = 'red'; */

export default {
    getRangeKey (calendarObject) {
        return `${calendarObject.month}-${calendarObject.year}`;
    },

    async getCalendarEntries(start, getCalendarEntries, filters) {
        return new Promise(async (resolve) => {
            const firstDayOfSelectedMonth = dateService.getFirstDayOfMonth(start.year, start.month - 1);
            const lastDayOfSelectedMonth = dateService.getLastDayOfMonth(start.year, start.month - 1);

            const response = await getCalendarEntries(
                { params: parseFilters({ from: firstDayOfSelectedMonth, until: lastDayOfSelectedMonth, ...filters })
            });

            resolve(response);
        });
    },

    mapCalendarApiResponseToCalendarObjects(calendarArray) {
        return calendarArray.map((calendarEntry) => {
            return {
                ...calendarEntry,
                /* color: WORK_CALENDAR_TYPE_COLORS[calendarEntry.type] ?? FALLBACK_COLOR, */
            }
        });
    },
};
